export default "__VITE_ASSET__D$JUIBv4__"